import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import style from './Section02.module.css'
import secImg01 from '../images/sec02_img01.png';
import secImg02 from '../images/sec02_img02.png';
import contentImg03 from '../images/sec02_img03.png';


function Section02({sec02Ref}) {

    const { t } = useTranslation();

    const marqueeTrackRef = useRef(null);
    const keywords = [
        'EXPORT TRUST.',
        'OWN THE VALUE.',
        'EXPORT TRUST.',
        'OWN THE VALUE.',
        'EXPORT TRUST.',
        'OWN THE VALUE.',
    ];

    useEffect(() => {
        const marqueeTrack = marqueeTrackRef.current;

        function startAnimation() {
            const contentWidth = marqueeTrack.scrollWidth / 2;
            marqueeTrack.style.transition = `transform 50s linear`;
            marqueeTrack.style.transform = `translateX(-${contentWidth}px)`;
        }

        marqueeTrack.addEventListener('transitionend', () => {
            marqueeTrack.style.transition = 'none';
            marqueeTrack.style.transform = `translateX(0)`;
            setTimeout(startAnimation, 0);
        });


        startAnimation();

        return () => {
            marqueeTrack.removeEventListener('transitionend', startAnimation);
        };
    }, []);

    return (
        <section className={style.wrap} ref={sec02Ref}>
            <div className={style.sec_title_box}>
                <div className={style.sec_title}>
                    <h4>
                        {t('Continuous network')} <br />
                        {t('growth built on expertise and trust')}
                    </h4>
                    <p>
                        {t('Building a stable global network through long-term partnerships.')}
                    </p>
                </div>
                <div className={style.sec_img}>
                    <div className={style.img_box_wrapper}>
                        <div className={`${style.img_box} ${style.img_box_01}`}>
                            <img src={secImg01} alt='전문성과 신뢰를 기반으로 한 지속적인 네트워크 확장' />
                        </div>
                        <div className={`${style.img_box} ${style.img_box_02}`}>
                            <img src={secImg02} alt='전문성과 신뢰를 기반으로 한 지속적인 네트워크 확장' />
                        </div>
                    </div>

                    <div className={style.rolling_box}>
                        <div className={style.rolling}>
                            <svg viewBox="0 0 300 300" className={style.rotating_text}>
                                <defs>
                                    <path
                                        id="rollingPath"
                                        d="M150,150 m-100,0 a100,100 0 1,1 200,0 a100,100 0 1,1 -200,0"
                                    />
                                </defs>
                                <text fontSize="28" fill="#1294E5">
                                    <textPath href="#rollingPath" startOffset="0%">
                                        PUFFU TRADE PUFFU TRADE PUFFU TRADE
                                    </textPath>
                                </text>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div className={style.content_box}>
                <div className={style.content}>
                    <h4>{t('Expanding markets, deepening partnerships')}</h4>
                    <p>{t('PUFFU TRADE is building a stable supply chain')}<br className={style.m_br} />
                        {t('with global partners in the e-cigarette industry.')}</p>
                </div>
                <div className={style.img_box}>
                    <img src={contentImg03} alt='넓어지는 시장, 깊어지는 파트너십' />
                </div>
                <div className={style.marquee_box}>
                    <div className={style.marqueeWrapper}>
                    <div className={style.marqueeTrack} ref={marqueeTrackRef}>
                        <div className={style.marqueeContent}>
                            {keywords.map((word, index) => (
                                <span className={style.keyword} key={`first-${index}`}>{word}</span>
                            ))}
                            {keywords.map((word, index) => (
                                <span className={style.keyword} key={`second-${index}`}>{word}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
                </div>
                
        </section>
    )
}

export default Section02;